/* eslint-disable radix */
/* eslint-disable no-redeclare */
import moment from "moment";
import { is_weekend } from "../../../../components/Modals/UOAModal/getDate";
import { firestore } from "../../../../fire";
export const getSmallest = (filteredExdiv) => {
  var a = moment();
  const getSmallest = filteredExdiv.map((element) => {
    var b = moment(element.date);
    var difference = b.diff(a);
    return { ...element, difference: difference };
  });
  return getSmallest.sort((a, b) => a.difference - b.difference);
};

export const calcChartDatas = async ({ props, setStateAction, modalRef }) => {
  const { dates } = props.state;
  const { OIDates } = props.appState;

  const {
    OIStrikes: strikes,
    OIDataCall: callsData,
    OIDataPut: putsData,
  } = props.appState;

  const modalStrikes = [...strikes];

  var callsChartData = Array(strikes.length).fill(0);
  var putsChartData = Array(strikes.length).fill(0);
  var indexs = [];
  for (var i = 0; i < dates.length; i++) {
    indexs.push(OIDates.indexOf(dates[i]));
  }

  for (var i = modalStrikes.length - 1; i >= 0; i--) {
    for (var j = 0; j < indexs.length; j++) {
      callsChartData[i] += parseFloat(callsData[i][indexs[j]]);
      putsChartData[i] += parseFloat(putsData[i][indexs[j]]);
    }
    if (callsChartData[i] === 0 && putsChartData[i] === 0) {
      modalStrikes.splice(i, 1);
      callsChartData.splice(i, 1);
      putsChartData.splice(i, 1);
    }
  }
  var callMax = Math.max(...callsChartData);
  var putMax = Math.max(...putsChartData);
  var count = 7;
  if (props.width < 850) count = 4;
  var step = Math.round(Math.max(callMax, putMax) / count);
  if (step > 1000) {
    step = Math.round(step / 1000) * 1000;
  } else if (step > 100) {
    step = Math.round(step / 100) * 100;
  }

  setStateAction({
    callsChartData,
    putsChartData,
    modalStrikes,
    step,
    max: Math.max(callMax, putMax),
  });

  const {
    quoteInfo: { latestPrice },
  } = props.appState;

  let strikeSliderPosition = 0;
  var currentRowIndex = 0;
  for (var i = 0; i < modalStrikes.length; i++) {
    if (modalStrikes[i] && latestPrice < modalStrikes[i]) {
      currentRowIndex = i - 1;
      break;
    }
  }
  const rowPos = currentRowIndex;
  var strikeDiff = 1;
  if (modalStrikes[rowPos + 1]) {
    strikeDiff = modalStrikes[rowPos + 1] - modalStrikes[rowPos];
  } else if (modalStrikes[rowPos]) {
    strikeDiff = modalStrikes[rowPos] - modalStrikes[rowPos - 1];
  }
  const priceDiff = latestPrice - modalStrikes[rowPos];
  strikeSliderPosition = rowPos + priceDiff / strikeDiff;

  setStateAction({ arrowPositionModal: strikeSliderPosition });
  setTimeout(() => {
    return modalRef.current.scrollTo(0, strikeSliderPosition * 20 - 150);
  }, 1000);
};

export const fetchEarningDates = async ({ props, setStateAction }) => {
  setStateAction({ earningToolTip: "", exToolTip: "" });
  try {
    if (Object.values(props.quoteInfo) && props.quoteInfo.symbol) {
      let earning = await firestore
        .collection("calendars")
        .doc(props.quoteInfo.symbol.replace("/", "-"))
        .get();

      let data = earning.data();
      let filteredEarning = Object.values(data).filter(
        (obj) => obj.type === "Earnings"
      );
      let filteredExdiv = Object.values(data).filter(
        (obj) => obj.type === "ExDiv"
      );
      if (filteredEarning.length) {
        let getResult = getSmallest(filteredEarning);
        setStateAction({
          earningToolTip: "Earnings: " + getResult[0].date,
        });
      }
      if (filteredExdiv.length) {
        let getResult = getSmallest(filteredExdiv);
        setStateAction({
          exToolTip: "Dividend:" + getResult[0].date,
        });
      }
    }
  } catch (error) {
    console.log(error);
  }
};
export const keyPressed = async (prop) => {
  const { e, props } = prop;
  if (e.keyCode === 13) {
    // put the login here
    props.setStateAction({
      localTicker: e.target.value,
      from: "-",
      to: "-",
      fromValue: 0,
      toValue: 99999999,
      percent: null,
      putsLimit: 99999999,
      callsLimit: 99999999,
      dates: [],
      showChart: false,
      putsChartData: [],
      callsChartData: [],
      modalStrikes: [],
      step: 1,
      max: 1,
    });
    props.refreshOpenInterest(e.target.value);
    window.scroll(0, 0);
    props.history.push(`/openinterest/${e.target.value}`);

  }
};

export const formatComma = (volume) => {
  return volume === 0
    ? "-"
    : volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const OIPercentFunction = ({ event, value, props }) => {
  props.setStateAction({ percent: value });
  const { fromValue, toValue } = props.state;
  const { OIDataCall, OIDataPut } = props.appState;
  const callsData = [...OIDataCall];
  const putsData = [...OIDataPut];
  props.setStateAction({ percent: value });
  var callsList = [];
  var putsList = [];
  if (callsData.length > 0) {
    for (var i = 0; i < callsData.length; i++) {
      if (callsData[i][0] >= fromValue && callsData[i][0] <= toValue) {
        var temp = [...callsData[i]];
        temp.splice(0, 1);
        callsList = callsList.concat(temp);
      }
    }
    callsList = callsList
      .filter((val) => +val !== 0)
      .map((val) => (typeof val === "string" ? parseFloat(val) : val))
      .sort(function (a, b) {
        return b - a;
      });
    for (var i = 0; i < putsData.length; i++) {
      if (putsData[i][0] >= fromValue && putsData[i][0] <= toValue) {
        var temp = [...putsData[i]];
        temp.splice(0, 1);
        putsList = putsList.concat(temp);
      }
    }
    putsList = putsList
      .filter((val) => +val !== 0)
      .map((val) => (typeof val === "string" ? parseFloat(val) : val))
      .sort(function (a, b) {
        return b - a;
      });
    var callsLimit = 0;
    var putsLimit = 0;
    if (value === "1") {
      callsLimit = callsList[parseInt(callsList.length / 100)];
      putsLimit = putsList[parseInt(putsList.length / 100)];
    } else if (value === "5") {
      callsLimit = callsList[parseInt(callsList.length / 20)];
      putsLimit = putsList[parseInt(putsList.length / 20)];
    } else if (value === "10") {
      callsLimit = callsList[parseInt(callsList.length / 10)];
      putsLimit = putsList[parseInt(putsList.length / 10)];
    }
    props.setStateAction({ callsLimit: callsLimit, putsLimit: putsLimit });
  }
};

export const OIbarOptionsPutsBottom = ({ isMobile, props }) => {
  return {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
            zeroLineColor: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            fontSize: isMobile ? 9 : 12,
            beginAtZero: true, //this will remove only the label
            callback: function (label, index, labels) {
              return label > 1000
                ? (label / 1000).toFixed(1).replace(/\.?0+$/, "") + "k"
                : label;
            },
            stepSize: props.state.step,
            max: props.state.max,
          },
          position: "top",
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
            zeroLineColor: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
  };
};
export const OIbarOptionsCallsBottom = ({ isMobile, props }) => {
  return {
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
            zeroLineColor: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            fontSize: isMobile ? 9 : 12,
            beginAtZero: true, //this will remove only the label
            reverse: true,
            callback: function (label, index, labels) {
              return label > 1000
                ? (label / 1000).toFixed(1).replace(/\.?0+$/, "") + "k"
                : label;
            },
            stepSize: props.state.step,
            max: props.state.max,
          },
          position: "top",
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
            zeroLineColor: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
  };
};

export const OIbarOptionsPutsfuntion = ({ props }) => {
  return {
    maintainAspectRatio: false,
    responsive: true,

    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true, //this will remove only the label
            display: false,
            stepSize: props.state.step,
            max: props.state.max,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      ],
    },
  };
};

export const barOptionsCallsFuntion = ({ props }) => {
  return {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true, //this will remove only the label
            display: false,
            reverse: true,
            stepSize: props.state.step,
            max: props.state.max,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            display: false,
          },
        },
      ],
    },
  };
};

export const OIPutData = ({ props, state }) => {
  return {
    labels: state.modalStrikes,
    datasets: [
      {
        backgroundColor: "rgb(200, 26, 0)",
        borderColor: "rgb(200, 26, 0)",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(200,26,0,0.8)",
        hoverBorderColor: "rgba(200,26,0,1)",
        label: "",
        barThickness: 16,
        maxBarThickness: 16,
        data: state.putsChartData,
      },
    ],
  };
};
export const OICallData = ({ props, state }) => {
  return {
    labels: state.modalStrikes,
    datasets: [
      {
        backgroundColor: "green",
        borderColor: "green",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(0,255,0,0.8)",
        hoverBorderColor: "rgba(0,255,0,1)",
        label: "",
        barThickness: 16,
        maxBarThickness: 16,
        data: state.callsChartData,
      },
    ],
  };
};

export const OIselectDateFunction = (row, props) => {
  const { dates } = props.state;
  const index = dates.indexOf(row);
  if (index !== -1) {
    dates.splice(index, 1);
  } else {
    dates.push(row);
  }
  props.setStateAction({ dates });
};
export const OIremoveDateFunction = (index, props) => {
  const { dates } = props.state;
  if (dates.length === 1) return;
  dates.splice(index, 1);
  props.setStateAction({ dates });
};
export const OItargetFromChangeFunction = async (value, props) => {
  if (value === "-") {
    props.setStateAction({
      from: value,
      fromValue: 0,
      callsLimit: 99999999,
      putsLimit: 99999999,
      percent: null,
      dates: [],
      showChart: false,
      putsChartData: [],
      callsChartData: [],
      modalStrikes: [],
      step: 1,
      max: 1,
    });
    return;
  }
};
export const OItargetToChangeFunction = async (value, props) => {
  if (value === "-") {
    props.setStateAction({
      to: value,
      toValue: 99999999,
      callsLimit: 99999999,
      putsLimit: 99999999,
      percent: null,
      dates: [],
      showChart: false,
      putsChartData: [],
      callsChartData: [],
      modalStrikes: [],
      step: 1,
      max: 1,
    });
    return;
  }
};

export const selectDateAndSaveTicker = (props) => {
  let date;
  let datetoSend;
  date = props.state.selectedDate;
  datetoSend = is_weekend(date);
  if (date) {
    props.setStateAction({ selectedDate: datetoSend });
  }
  props.match.params.ticker &&
    localStorage.setItem("SYMBOL", props.match.params.ticker.toUpperCase());
  localStorage.setItem("TYPE", "calls");
  const type = localStorage.getItem("TYPE");
  const symbol = localStorage.getItem("SYMBOL");
  localStorage.setItem("SYMBOL", "");
  if (type !== "") {
    props.setStateAction({ type: type });
    props.setStateAction({ localTicker: symbol });
    props.history.push("/openinterest/" + symbol);
    props.changeTicker(symbol).then(() => {
      props.refreshOpenInterest(symbol);
      window.scroll(0, 0);
    });
  } else {
    props.setStateAction({ type: "calls" });
  }
};

export const OIConditionAndFetch = async ({
  prevProps,
  props,
  modalRef,
  tableRef,
  setStateAction,
}) => {
  const { appState } = prevProps;
  const { appState: appState2 } = props;
  const {
    quoteInfo: { latestPrice: prevLatestPrice },
    OIDataCall: prevCallsData,
  } = appState;

  const {
    quoteInfo: { latestPrice },
    OIDataCall: callsData,
  } = appState2;

  if (prevProps.quoteInfo !== props.quoteInfo) {
    console.log("oop");
    const obj = {
      props: props,
      setStateAction: setStateAction,
      modalRef: modalRef,
    };
    const res = await fetchEarningDates(obj);
    return res;
  }

  if (prevCallsData !== callsData || latestPrice !== prevLatestPrice) {
    let strikeSliderPosition = 0;
    if (callsData.length > 0) {
      var currentRowIndex = 0;
      for (var i = 0; i < callsData.length; i++) {
        if (callsData[i] && latestPrice < callsData[i][0]) {
          currentRowIndex = i - 1;
          break;
        }
      }
      const rowPos = currentRowIndex;

      if (rowPos !== -1) {
        var strikeDiff = 1;
        if (callsData[rowPos + 1]) {
          strikeDiff = callsData[rowPos + 1][0] - callsData[rowPos][0];
        } else if (callsData[rowPos]) {
          strikeDiff = callsData[rowPos][0] - callsData[rowPos - 1][0];
        }
        const priceDiff = latestPrice - callsData[rowPos][0];
        strikeSliderPosition =
          0.05 + // Offset due to arrow being slightly smaller
          rowPos +
          priceDiff / strikeDiff;
        props.setStateAction({ arrowPosition: strikeSliderPosition });
        tableRef.current.scrollTo(0, strikeSliderPosition * 30 - 150);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/utils/utils.js